import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
//import Routes from "./Routes";

ReactDOM.render(
  <React.StrictMode>
    
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
